export default __webpack_public_path__ + "static/media/Geometria.3d0e8faf.woff";